'use client';

import { useState } from 'react';
import { Box, Select, MenuItem, FormControl } from '@mui/material';
import ReportCards from './ReportCards';

import { useLanguage } from '../../utils/i18n';

const ReportPage = () => {
  const { t } = useLanguage();
  const [category, setCategory] = useState('all');

  return (
    <Box>
      <FormControl sx={{ minWidth: 200, mb: 3 }}>
        <Select
          value={category}
          // label={t('reports.category', 'Category')}
          onChange={(e) => setCategory(e.target.value)}
          sx={{
            borderRadius: '8px',
            '& .MuiSelect-icon': { color: 'primary.main' },
            '& .MuiOutlinedInput-notchedOutline': {
              borderColor: '#485D9A'
            }
          }}
        >
          <MenuItem value="all">
            {t('reports.all', 'All')} {t('reportModule.catalog', 'Catalog')}
          </MenuItem>
          <MenuItem value="fleet">{t('reports.fleet', 'Fleet')}</MenuItem>
          <MenuItem value="fuel">{t('reports.fuel', 'Fuel')}</MenuItem>
          <MenuItem value="ritase">{t('reports.ritase', 'Ritase')}</MenuItem>
          <MenuItem value="fleet_ev">{t('reports.evFleetEnergyReport', 'EV Fleet Energy Report')}</MenuItem>
        </Select>
      </FormControl>

      <ReportCards category={category} />
    </Box>
  );
};

export default ReportPage;
